import { render, staticRenderFns } from "./Activity1_3.vue?vue&type=template&id=df36cf3a&scoped=true&"
import script from "./Activity1_3.vue?vue&type=script&lang=js&"
export * from "./Activity1_3.vue?vue&type=script&lang=js&"
import style0 from "./Activity1_3.vue?vue&type=style&index=0&id=df36cf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df36cf3a",
  null
  
)

export default component.exports